import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";
import { Navigate, useSearchParams } from "react-router-dom";

import type { CrmDataProvider } from "../providers/types";
import { LoginSkeleton } from "./LoginSkeleton";
import { LoginPage } from "./LoginPage";
import { disableEmailPasswordAuthentication } from "./authConfig";

export const StartPage = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  // Preserve a post-login return target (e.g. the OAuth consent page) across the OTP login.
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect") || undefined;
  const {
    data: isInitialized,
    error,
    isPending,
  } = useQuery({
    queryKey: ["init"],
    queryFn: async () => {
      return dataProvider.isInitialized();
    },
  });

  if (isPending) return <LoginSkeleton />;
  if (error) return <LoginPage redirectTo={redirectTo} />;
  if (isInitialized) return <LoginPage redirectTo={redirectTo} />;
  if (disableEmailPasswordAuthentication)
    return <LoginPage redirectTo={redirectTo} />;

  return <Navigate to="/sign-up" />;
};
